import { c as _c } from "react/compiler-runtime";
import { groupOutcomesByCount } from '../../../../lib/entry.browser.js';
import { useSubscribedCoupon } from './useSubscribedCoupon.js';
/**
 * Calculates and groups selections by hedge count.
 *
 * @param root0 Hook arguments
 * @param root0.couponId Unique id of the coupon
 * @param root0.couponIndex Specific coupon id in order
 * @returns Grouped outcome selections by Record&lt;Selection hedge count, Number of occupancies>
 */
export function useCouponGroupedOutcomes(t0) {
  const $ = _c(3);
  const {
    couponId,
    couponIndex
  } = t0;
  let t1;
  if ($[0] !== couponId || $[1] !== couponIndex) {
    t1 = {
      couponId,
      couponIndex,
      selector: _temp
    };
    $[0] = couponId;
    $[1] = couponIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const outcomeGroups = useSubscribedCoupon(t1);
  return outcomeGroups;
}
function _temp(coupon) {
  const groups = {};
  if (!coupon) {
    return groups;
  }
  for (const board of coupon.boards) {
    const boardGroup = groupOutcomesByCount(board, coupon.selectedSystem);
    for (const [group, groupCount] of Object.entries(boardGroup)) {
      const counter = groups[Number(group)] ?? 0;
      groups[Number(group)] = counter + groupCount;
    }
  }
  return groups;
}